<template>
        <div class="card is-info clickable mb10" @click='selectNews'>
                <div class="card-content">

                        <div class="media" v-if="item.creator && item.creator.profile">
                                <div class="media-left">
                                        <figure class="image is-48x48">
                                                <img class="round" :src="axios.defaults.storageURL + item.creator.profile.avatar" :alt="item.creator.profile.nick">
                                        </figure>
                                </div>
                                <div class="media-content">
                                        <p class="title is-4">{{item.creator.profile.name}} <span v-if="item.pivot.seen == 0" class="tag is-danger is-pulled-right has-text-weight-normal">new</span></p>
                                        <p class="subtitle is-6">@{{item.creator.profile.nick}}</p>
                                </div>
                        </div>

                        <div class="content minimal-vertical-margin minimal-vertical-padding">
                                <h2 class="title is-5 has-text-primary"> {{item.title}}</h2>
                                <p class="has-text-grey-dark multiline-text"> {{item.description}} </p>
                                <a href="javascript:{}" @click="selectNews" class="is-link"><u>Read more...</u></a>
                                <p class="is-size-7 has-text-right"><time datetime="2016-1-1"><i>{{item.created_human}}</i></time></p>
                        </div>

                </div>
        </div>
</template>
<script>

    import _ from 'lodash'

    export default {
        name: 'NewsItem',
        components: {},
        props:['item'],
        data() {
            return {

            }
        },
        created(){

        },
        mounted(){

        },
        methods: {
            selectNews(){
                this.$router.push('/dashboard/news/'+ this.item.id);
            }
        },
        watch: {

        }

    }
</script>

<style lang="css" scoped>

        .mb10{
                margin-bottom: 10px;
        }
</style>



// WEBPACK FOOTER //
// src/components/news/NewsItem.vue